import { Heading } from 'blaze-ui/Heading/Heading'
import Styles from './Cta.module.scss'

import { Modal } from 'almanac-ui/Modal'
import { Button } from 'blaze-ui/Button'
import { ColumnVertical1, Send1, Target2, TemplatesFilled, UsersProfiles1 } from 'blaze-ui/icons'
import Server02 from 'blaze-ui/icons/16/Server02'
import { Text } from 'blaze-ui/Text/Text'

export const Cta = ({
  onCancel,
  onConfirm,
  isTrialing,
  onUpgradeToGrowth,
}: {
  onCancel: () => void
  onConfirm: () => void
  isTrialing: boolean
  onUpgradeToGrowth: () => void
}) => {
  return (
    <Modal.Content className={Styles.modalContent}>
      <div className={Styles.container}>
        <div className={Styles.leftSection}>
          <div className={Styles.contentWrapper}>
            <div className={Styles.content}>
              <Heading level={1}>Upgrade to Growth to unlock full access</Heading>
              <div className={Styles.features}>
                <Heading level={5}>Scale your marketing without limits:</Heading>
                <div className={Styles.feature}>
                  <Send1 color="var(--blue-50)" size={24} />
                  <Text>Unlimited posting & cross-posting</Text>
                </div>
                <div className={Styles.feature}>
                  <TemplatesFilled color="var(--blue-50)" size={24} />
                  <Text>Unlimited posting channels</Text>
                </div>
                <div className={Styles.feature}>
                  <UsersProfiles1 color="var(--blue-50)" size={24} />
                  <Text>Unlimited seats and multi-user workflow</Text>
                </div>
                <div className={Styles.feature}>
                  <ColumnVertical1 color="var(--blue-50)" size={24} />
                  <Text>Parallel campaigns</Text>
                </div>
                <div className={Styles.feature}>
                  <Target2 color="var(--blue-50)" size={24} />
                  <Text>AI ad management</Text>
                </div>
                <div className={Styles.feature}>
                  <Server02 size={24} color="var(--blue-50)" />
                  <Text>1200 generation credits</Text>
                </div>
              </div>
              <Button fullWidth onPress={onUpgradeToGrowth} size="xl">
                Continue with Growth Plan
              </Button>
            </div>
          </div>
          <div className={Styles.footer}>
            <Button variant="tertiary" onPress={onCancel} size="lg">
              Close
            </Button>
            <div className={Styles.right}>
              <Button variant="tertiary" onPress={onConfirm} size="lg">
                See All Plans
              </Button>
            </div>
          </div>
        </div>
        <div className={Styles.rightSection}></div>
      </div>
    </Modal.Content>
  )
}
